import { render } from "./SourcesPercentage.vue?vue&type=template&id=715dfdf4"
import script from "./SourcesPercentage.vue?vue&type=script&lang=js"
export * from "./SourcesPercentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__